import toast from "react-hot-toast";

export function showNotificationToast(options: {
  id: string;
  title: string;
  subject: string;
  viewLabel: string;
  onView: () => void;
  duration?: number;
}) {
  toast.custom(
    (toastValue) => (
      <button
        type="button"
        onClick={() => {
          toast.dismiss(toastValue.id);
          options.onView();
        }}
        className="flex w-[min(360px,calc(100vw-2rem))] flex-col gap-1 rounded-lg border border-[#E3E0D6] bg-card px-3.5 py-3 text-left shadow-lg"
      >
        <span className="text-[11px] font-medium tracking-wide text-primary">
          {options.title}
        </span>
        <span className="text-[13px] font-medium leading-snug text-foreground">
          {options.subject}
        </span>
        <span className="text-[12px] font-medium text-primary">{options.viewLabel}</span>
      </button>
    ),
    { id: options.id, duration: options.duration ?? 5000 },
  );
}
